import { useContext, useState } from "react";
import { useCreateBulkExpenseMutation } from "../../../../hooks/api/mutations/expenses";
import { ToastContext } from "../../../../hooks/context";
import { cleanObject } from "../../../../helpers";
import { pathConstants } from "../../../../routes/pathContants";
import { useNavigate } from "react-router-dom";

export const useBulkExpenseForm = () => {
  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();
  const [bulkForm, setBulkForm] = useState({
    store_ids: [],
    expenses: [],
  });

  const getDataForSubmission = () => {
    return cleanObject({
      ...bulkForm,

      expenses: bulkForm?.expenses?.map((item) => {
        return cleanObject(
          {
            ...item,
          },
          ["id"],
        );
      }),
    });
  };

  const { mutate: createBulkExpense, isLoading: isCreatingExpense } =
    useCreateBulkExpenseMutation();

  const handleCreateExpense = () => {
    if (bulkForm?.expenses?.length === 0)
      return triggerToast("Please add items to the Goods received", "warning");

    const data = getDataForSubmission();

    createBulkExpense(
      { ...data },
      {
        onSuccess: () => {
          triggerToast("Bulk expense created successfully", "success");
          navigate(pathConstants.EXPENSES_LIST({}));
        },
      },
    );
  };

  return { isCreatingExpense, bulkForm, setBulkForm, handleCreateExpense };
};
